import { ICON_TYPES } from '../constants';

export const LeftArrowIcon = (): JSX.Element => {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.354 1.146a.5.5 0 0 1 0 .708L5.207 8l6.147 6.146a.5.5 0 0 1-.708.708l-6.5-6.5a.5.5 0 0 1 0-.708l6.5-6.5a.5.5 0 0 1 .708 0Z"
        fill="currentColor"
      ></path>
    </svg>
  );
};

LeftArrowIcon.iconType = ICON_TYPES.LEFTARROW;
